import React from "react";
import SelectInput from "../widgets/SelectInput";
import getLezioniCorso from "../services/getLezioniCorso";
import getCorsi from "../services/getCorsi";
import addRichiestaRecupero from "../services/addRichiestaRecupero";
import getLezioneRecuperata from "../services/getLezioneRecuperata";
import getPresenzeCorso from "../services/getPresenzeCorso";
import Cookies from "universal-cookie";
import FixButton from "./Button";
import moment from "moment";
import "moment/locale/it";

export default class EditRecuperoLezioneWidget extends React.Component {
  constructor(props) {
    super(props);

    // Configura moment.js per l'italiano
    moment.locale("it");

    this.state = {
      isSaving: false,
      note: props.initialNote || "",
      isLoadingNote: true,
      corsiPerRecupero: [],
      lezioni: [], // Lezioni già espanse dal backend (include sessioni)
      selectedLezione: null,
      selectedCorso: null,
      presenzeStudente: [], // presenze dello studente per filtrare lezioni
      isLoadingLezioni: false, // Indicatore di caricamento
    };
  }

  componentDidMount() {
    this.loadExistingNote();
    // Se non è modalità "solo note", carica anche i corsi
    if (!this.props.onlyNotes) {
      this.reload();
    }
  }

  reload() {
    this.getCorsiForRecupero();
  }

  getCorsiForRecupero() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const corsoId = cookies.get("currentCourse", { path: "/" });

    getCorsi(username, token)
      .then((corsi) => {
        const corso = corsi.find((c) => Number(c.id) === Number(corsoId));
        if (corso) {
          this.setState({
            corsiPerRecupero: corsi.filter(
              (c) => Number(c.id_categoria) === Number(corso.id_categoria)
            ),
          });
        } else {
          throw new Error("Corso non trovato");
        }
      })
      .catch((error) => {
        console.error("Error fetching corsi:", error);
      });
  }

  async getLezioniForCorso(corsoId) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.setState({ isLoadingLezioni: true });

    try {
      // Carica sia le lezioni (già espanse dal backend) che le presenze
      const [lezioni, presenze] = await Promise.all([
        getLezioniCorso(username, token, corsoId),
        getPresenzeCorso(username, token, corsoId),
      ]);

      console.log("[EditRecupero] Lezioni dal backend (già espanse):", lezioni);
      console.log("[EditRecupero] Presenze for corsoId:", corsoId, presenze);

      // Ottieni l'ID dello studente
      const studenteId = this.props.studente?.id || this.props.studente;

      // Filtra le presenze dello studente
      const presenzeStudente = presenze.filter(
        (p) => p.id_studente == studenteId
      );

      // Filtra le lezioni: escludi solo quelle dove lo studente è ASSENTE
      // Permetti: lezioni future (senza presenza) e lezioni dove è presente
      // NOTA: le lezioni sono già espanse per sessione dal backend
      const lezioniDisponibili = lezioni.filter((lezione) => {
        // Per le sessioni, consideriamo il filtro a livello di lezione
        const presenza = presenzeStudente.find(
          (p) => p.id_lezione == lezione.id
        );

        // Se non c'è presenza (lezione futura), è disponibile
        if (!presenza) return true;

        // Se c'è presenza, escludi solo se è assente (presenza == -1)
        return presenza.presenza !== -1;
      });

      console.log(
        `[EditRecuperoLezioneWidget] Lezioni disponibili per recupero: ${lezioniDisponibili.length} su ${lezioni.length}`
      );

      this.setState({
        lezioni: lezioniDisponibili,
        presenzeStudente: presenzeStudente,
        isLoadingLezioni: false,
      });
    } catch (error) {
      console.error("Error fetching lezioni:", error);
      this.setState({ isLoadingLezioni: false });
    }
  }

  async loadExistingNote() {
    // Se viene passata una nota iniziale, usala
    if (this.props.initialNote) {
      this.setState({
        note: this.props.initialNote,
        isLoadingNote: false,
      });
      return;
    }

    // Altrimenti, se esiste già un recupero, carica le note dal backend
    if (this.props.id_recupero_lezione) {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });

      try {
        const recuperoInfo = await getLezioneRecuperata(
          username,
          token,
          this.props.id_recupero_lezione
        );

        if (recuperoInfo && recuperoInfo.result === "ok") {
          // Carica le note esistenti se disponibili
          this.setState({
            note: recuperoInfo.note || recuperoInfo.note_recupero || "",
            isLoadingNote: false,
          });
        } else {
          this.setState({ isLoadingNote: false });
        }
      } catch (error) {
        console.error("Errore nel caricamento delle note del recupero:", error);
        this.setState({ isLoadingNote: false });
      }
    } else {
      this.setState({ isLoadingNote: false });
    }
  }

  async salvaRichiestaRecupero() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const idRichiestaRecupero = this.props.id_recupero_lezione;
    const note = this.state.note;

    // Verifica che ci sia un ID recupero
    if (!idRichiestaRecupero) {
      alert("Errore: ID recupero mancante");
      return;
    }

    // Se non è modalità "solo note", verifica che sia selezionata una lezione
    if (!this.props.onlyNotes && !this.state.selectedLezione) {
      alert("Seleziona una lezione per il recupero");
      return;
    }

    try {
      this.setState({ isSaving: true });

      // Estrai id_lezione e id_sessione dalla selezione
      const idLezioneRecupero = this.props.onlyNotes
        ? null
        : this.state.selectedLezione.id_lezione;

      const idSessioneRecupero = this.props.onlyNotes
        ? null
        : this.state.selectedLezione.id_sessione;

      console.log(
        "[EditRecuperoLezioneWidget] Parametri chiamata addRichiestaRecupero:",
        {
          username,
          token: token ? "presente" : "mancante",
          idLezioneRecupero,
          idRichiestaRecupero,
          note,
          idSessioneAssenza: this.props.id_sessione,
          idSessioneRecupero,
          onlyNotes: this.props.onlyNotes,
        }
      );

      const resp = await addRichiestaRecupero(
        username,
        token,
        idLezioneRecupero,
        idRichiestaRecupero,
        note,
        this.props.id_sessione, // id_sessione dell'assenza originale
        idSessioneRecupero // id_sessione per il recupero
      );

      console.log(
        "[EditRecuperoLezioneWidget] Risposta da addRichiestaRecupero:",
        resp
      );

      if (resp && resp.result === "ok") {
        const messaggio = this.props.onlyNotes
          ? "Note salvate con successo!"
          : "Recupero salvato con successo!";
        alert(messaggio);
        console.log(
          "EditRecuperoLezioneWidget: Salvato, chiamando reloadRecupero"
        );
        if (this.props.reloadRecupero) {
          this.props.reloadRecupero();
        }
      } else if (resp && resp.success === false) {
        const messaggio = this.props.onlyNotes
          ? "Errore nel salvataggio delle note: " +
            (resp.message || "Errore sconosciuto")
          : "Errore nel salvataggio del recupero: " +
            (resp.message || "Errore sconosciuto");
        alert(messaggio);
        console.error(
          "[EditRecuperoLezioneWidget] Errore dalla risposta:",
          resp
        );
      } else {
        const messaggio = this.props.onlyNotes
          ? "Errore nel salvataggio delle note"
          : "Errore nel salvataggio del recupero";
        alert(messaggio);
        console.error("[EditRecuperoLezioneWidget] Risposta non valida:", resp);
      }
    } catch (err) {
      console.error("Errore:", err);
      const messaggio = this.props.onlyNotes
        ? "Errore durante il salvataggio delle note"
        : "Errore durante il salvataggio del recupero";
      alert(messaggio);
    } finally {
      this.setState({ isSaving: false });
      this.props.onClose();
    }
  }

  render() {
    const isOnlyNotes = this.props.onlyNotes;
    const titleText = isOnlyNotes
      ? "Modifica Note Recupero"
      : "Recupera Lezione";
    const buttonText = isOnlyNotes ? "Salva Note" : "Salva Recupero";

    return (
      <div style={cardClass}>
        <div
          style={closeIcon}
          onClick={() => {
            this.props.onClose();
          }}
        >
          X
        </div>
        <div className="windowTitle" style={{ color: "black" }}>
          {titleText}
        </div>
        <div
          style={{
            marginTop: "10px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          {(this.props.studente?.cognome || "") +
            " " +
            (this.props.studente?.nome || "")}
        </div>

        {/* Mostra selezione corso e lezione solo se NON è modalità "solo note" */}
        {!isOnlyNotes && (
          <>
            <SelectInput
              style={{ marginTop: "20px" }}
              options={
                this.state.corsiPerRecupero.map((c) => ({
                  value: c.id,
                  label: c.name,
                })) ?? []
              }
              onChange={(val) => {
                this.setState({ selectedCorso: val });
                this.getLezioniForCorso(val.value);
              }}
              value={this.state.selectedCorso}
              placeholder="Seleziona un corso"
            />
            {this.state.isLoadingLezioni ? (
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                  color: "#666",
                }}
              >
                ⏳ Caricamento lezioni...
              </div>
            ) : null}
            {this.state.selectedCorso && !this.state.isLoadingLezioni ? (
              <SelectInput
                style={{ marginTop: "20px" }}
                options={(this.state.lezioni || []).map((l) => {
                  console.log("[EditRecupero] Dati lezione dal backend:", l);

                  // Formatta la data
                  let formattedDate = "";
                  let oraFormatted = "";

                  if (l.data) {
                    const dataMoment = moment(l.data);
                    formattedDate = dataMoment.format("DD/MM/YYYY");

                    // Usa l'orario della sessione se disponibile (dal backend)
                    if (l.is_sessione && l.sessione_ora_inizio) {
                      // Rimuovi i secondi dall'orario (da HH:mm:ss a HH:mm)
                      const oraSenzaSecondi = l.sessione_ora_inizio.substring(
                        0,
                        5
                      );
                      oraFormatted = ` ore ${oraSenzaSecondi}`;
                    } else if (l.ora_inizio) {
                      // Fallback all'ora della lezione principale, rimuovi i secondi
                      const oraSenzaSecondi = l.ora_inizio.substring(0, 5);
                      oraFormatted = ` ore ${oraSenzaSecondi}`;
                    }
                  }

                  // Materia (già fornita dal backend per sessione)
                  const materia = l.str_materia ? ` - ${l.str_materia}` : "";

                  // Label sessione (già fornita dal backend)
                  const sessioneLabel =
                    l.is_sessione && l.label_sessione
                      ? ` - ${l.label_sessione}`
                      : "";

                  // Il value deve includere l'id_sessione se presente
                  const valueObj = l.is_sessione
                    ? `${l.id}_${l.id_sessione}`
                    : l.id;

                  return {
                    value: valueObj,
                    label: `${formattedDate}${oraFormatted}${materia}${sessioneLabel}`,
                    id_lezione: l.id,
                    id_sessione: l.id_sessione || null,
                    is_sessione: l.is_sessione,
                  };
                })}
                onChange={(val) => {
                  this.setState({ selectedLezione: val });
                }}
                value={this.state.selectedLezione}
                placeholder="Seleziona una lezione"
              />
            ) : null}
          </>
        )}

        {/* Campo per le note del recupero */}
        <div style={{ marginTop: "30px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "12px",
              fontWeight: "bold",
              color: "#333",
              fontSize: "16px",
            }}
          >
            Note del Recupero:
          </label>
          <textarea
            style={{
              width: "100%",
              minHeight: isOnlyNotes ? "200px" : "120px",
              padding: "15px",
              borderRadius: "4px",
              border: "2px solid #2196F3",
              fontFamily: "inherit",
              fontSize: "15px",
              resize: "vertical",
              boxSizing: "border-box",
            }}
            placeholder="Inserisci eventuali note sul recupero..."
            value={this.state.note}
            onChange={(e) => this.setState({ note: e.target.value })}
            disabled={this.state.isLoadingNote}
            autoFocus={isOnlyNotes}
          />
          {this.state.isLoadingNote && (
            <small
              style={{ color: "#666", marginTop: "5px", display: "block" }}
            >
              Caricamento note esistenti...
            </small>
          )}
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
          <FixButton
            title={buttonText}
            disabled={this.state.isSaving}
            callback={() => this.salvaRichiestaRecupero()}
          />
          <FixButton
            title="Annulla"
            callback={() => {
              this.props.onClose();
            }}
          />
        </div>
      </div>
    );
  }
}

const cardClass = {
  position: "fixed",
  left: "45%",
  top: "20%",
  background: "#ffffff",
  border: "1px solid black",
  padding: "20px",
  overflow: "scroll",
  zIndex: 999,
};

const closeIcon = {
  position: "absolute",
  cursor: "pointer",
  right: 0,
  top: 0,
  padding: 10,
};
